import axios from 'axios'
import qs from 'qs'

export function postProductReview ({productId, rating, body}, captcha) {
  let data = {
    review: {
      productId: productId,
      rating: rating,
      body: body
    }
  }

  if (captcha) {
    data['g-recaptcha-response'] = captcha
  }

  return axios.post('/?fc=module&module=dbs_productsreviews&controller=api',
    qs.stringify(data), {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
}

export async function addProductReview (review, captcha) {
  const response = await postProductReview(review, captcha)

  return response.data
}



// WEBPACK FOOTER //
// ./src/api/productReviews/addProductReview.js